var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndicators(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 5C12.3954 5 11.5 5.89543 11.5 7V10H13.5V11H11.5L11.5 17C11.5 18.6569 10.1569 20 8.5 20C6.84315 20 5.5 18.6569 5.5 17H6.5C6.5 18.1046 7.39543 19 8.5 19C9.60457 19 10.5 18.1046 10.5 17L10.5 11H8.5V10H10.5V7C10.5 5.34315 11.8431 4 13.5 4C15.1569 4 16.5 5.34315 16.5 7H15.5C15.5 5.89543 14.6046 5 13.5 5Z",
    fill: "#848E9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8492 15.0009C17.8486 15.0003 17.848 15 17.848 15C17.848 15 17.8464 15.0003 17.8459 15.0009L16 16.8467L14.1542 15.0009C14.1536 15.0003 14.153 15 14.153 15H14.152C14.1517 15.0001 14.151 15.0006 14.1508 15.0008L13.5009 15.6508C13.5003 15.6514 13.5 15.6519 13.5 15.6519V15.653L13.5009 15.6542L15.3467 17.5L13.5009 19.3458C13.5003 19.3464 13.5 19.347 13.5 19.347V19.348C13.5002 19.3485 13.5005 19.3489 13.5008 19.3492L14.1508 19.9991C14.1514 19.9997 14.1519 20 14.1519 20H14.153C14.153 20 14.1536 19.9997 14.1542 19.9991L16 18.1533L17.8458 19.9991C17.8464 19.9997 17.847 20 17.847 20H17.848C17.8482 19.9999 17.849 19.9994 17.8492 19.9992L18.4991 19.3492C18.4997 19.3486 18.5 19.3481 18.5 19.3481V19.347L18.4991 19.3458L16.6533 17.5L18.4991 15.6542C18.4997 15.6536 18.5 15.653 18.5 15.653V15.652C18.5 15.652 18.4997 15.6513 18.4992 15.6508L17.8492 15.0009Z",
    fill: "#848E9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicators);
export default __webpack_public_path__ + "static/media/indicators.1c6d23037788d1a39455a2b68fe57d59.svg";
export { ForwardRef as ReactComponent };